import { render, staticRenderFns } from "./VTeam.vue?vue&type=template&id=5ddbb690&"
import script from "./VTeam.vue?vue&type=script&lang=js&"
export * from "./VTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/emileeang/Documents/works/autoag/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddbb690')) {
      api.createRecord('5ddbb690', component.options)
    } else {
      api.reload('5ddbb690', component.options)
    }
    module.hot.accept("./VTeam.vue?vue&type=template&id=5ddbb690&", function () {
      api.rerender('5ddbb690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VTeam/VTeam.vue"
export default component.exports